/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";

const { isAuthenticated } = {};

const LandingPage = lazy(() => import("../pages/Landing"));
const ProductViewPage = lazy(() => import("../pages/ProductView"));
const ProductDetailViewPage = lazy(() => import("../pages/ProductDetailView"));
const ProvenanceStepDetailPage = lazy(
    () => import("../pages/ProvenanceStepDetailView")
);
const MainViewPage = lazy(() => import("../pages/MainPage"));
const ProvenanceViewPage = lazy(() => import("../pages/ProvenancePage"));
const TermsPage = lazy(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazy(() => import("../pages/PrivacyPolicy"));

// const DetailsComponent = lazy(
//     () => import("../pages/ProductView/components/ProductDetails")
// );
// import { ProductInfoScreen } from "../pages/ProductView/components/ProductInfoScreen"

const RouterConfig = (props) => (
    <Switch>
        {/* <Route path="/productDetail" component={DetailsComponent} /> */}
        {/* <Route path="/info" component={ProductInfoScreen} /> */}
        <Route path="/product-provenance" component={ProvenanceViewPage} />
        <Route path="/product-detail" component={ProductDetailViewPage} />
        <Route path="/product" component={MainViewPage} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route path="/" component={LandingPage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/login`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW />}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
